import { useTranslation } from 'react-i18next';
import { YearMonthDayPickerFieldProps, YearMonthDayPickerField } from '@anytag/shared-molecules';
import { InfluencerFormKeys } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

export const DateOfBirthField = (props: Omit<YearMonthDayPickerFieldProps, 'name' | 'format'>) => {
  const { t } = useTranslation();

  return (
    // TODO: New design using date picker component. Recheck after Anyui supports it.
    // https://www.figma.com/design/MPWUOUncfDs1qyc8QXbyNM/AnyTag-New-Design?node-id=636-95125&m=dev
    <YearMonthDayPickerField<InfluencerFormKeys>
      format="yyyy-MM-dd"
      help={t('Tooltip.Date Of Birth')}
      maxDate={new Date()}
      title={t('TextForm.Date Of Birth')}
      name={InfluencerSharedKeys.dateOfBirth}
      {...props}
    />
  );
};
